import React, { useState, useEffect } from 'react'
import AdminLayout from '../../components/admin/AdminLayout'
import { useAuth } from '../../context/AuthContext'
import { API_BASE } from '../../utils/api'
import { useNavigate, useParams } from 'react-router-dom'

export default function AdminEditPropertyType() {
    const { token } = useAuth()
    const navigate = useNavigate()
    const { id } = useParams()
    const [name, setName] = useState('')
    const [saving, setSaving] = useState(false)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchType = async () => {
            try {
                const res = await fetch(`${API_BASE}/property-types/${id}`)
                const data = await res.json()
                if (res.ok) {
                    setName(data.name)
                } else {
                    alert(data.message || 'Failed to load property type')
                    navigate('/admin-property-types')
                }
            } catch (err) {
                console.error(err)
            } finally {
                setLoading(false)
            }
        }
        if (id) fetchType()
    }, [id, navigate])

    const handleSave = async () => {
        if (!name) return alert('Name required')
        setSaving(true)
        try {
            const res = await fetch(`${API_BASE}/property-types/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ name })
            })
            const data = await res.json()
            if (res.ok) {
                navigate('/admin-property-types')
            } else {
                alert(data.message || 'Failed to save')
            }
        } catch (err) {
            console.error(err)
            alert('An error occurred while saving')
        } finally {
            setSaving(false)
        }
    }

    return (
        <AdminLayout>
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-black">Edit Property Type</h1>
            </div>
            <div className="bg-white p-6 rounded-md border">
                {loading ? (
                    <div className="py-10 text-center">Loading...</div>
                ) : (
                    <>
                        <label className="block mb-2 font-bold text-black">Name</label>
                        <input
                            value={name}
                            onChange={e => setName(e.target.value)}
                            className="w-full p-3 border rounded mb-4 text-black"
                            placeholder="e.g. Residential"
                        />
                        <div className="flex gap-2">
                                 <button
                                    className="px-5 py-2 bg-white border-2 border-[#05144b] text-[#05144b] hover:bg-blue-50 rounded font-bold transition-all shadow-md active:scale-95"
                                    onClick={handleSave}
                                    disabled={saving}
                                >
                                    {saving ? 'Saving...' : 'Update Property Type'}
                                </button>
                            <button
                                className="px-5 py-2 border rounded font-bold text-black"
                                onClick={() => navigate('/admin-property-types')}
                            >
                                Cancel
                            </button>
                        </div>
                    </>
                )}
            </div>
        </AdminLayout>
    )
}
